module.exports = __webpack_public_path__ + "static/img/loading_flower.6b3ec29.gif";


//////////////////
// WEBPACK FOOTER
// ../common/img/loading_flower.gif
// module id = ijNi
// module chunks = 1